export default __webpack_public_path__ + "static/media/school-logo.720750bd.svg";